import { requestHandler } from "../lib/utils/network-client";

export function getCareerApplications(params = {}) {
  return requestHandler("/career-applications", {
    params
  });
}
